import(/* webpackMode: "eager" */ "/codebuild/output/src1295702971/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/not-found.tsx");
